import {Component} from "react";
import FormatMessage from "../../messages/FormatMessage";

class EQLeftNavigationTree extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const sectionKeys = []
        for (var i = 1; i <= 10; i++) {
            sectionKeys.push(
                <FormatMessage id={this.props.closedSectionKey + "." + i}>
                    {(message) => !message.toString().includes(this.props.closedSectionKey.toString()) ?
                        <a key={i} className="link-primary locked">
                            <span>{message}</span>
                        </a> : ""
                    }
                </FormatMessage>)
        }
        return (
            <div className="SidebarNav SidebarNav-eq">
                <a className="link-primary selected">
                    <span><FormatMessage id="eq.lnt.section.open"/></span>
                </a>
                {sectionKeys}
            </div>
        )
    }
}

export default EQLeftNavigationTree
